define('app/sds/bar/sds-bar-factory',["constant!sds-bar-prototype"], function (barPrototype) {
	return sdsBarFactory;
	function sdsBarFactory(obj) {
		return angular.extend(Object.create(barPrototype), obj);
	}
});
